import React, { useEffect, useState } from "react";
import {
  FaHome,
  FaFilm,
  FaTv,
  FaCog,
  FaBars,
  FaUser,
  FaSignOutAlt,
} from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Movies from "./components/Movies"; // Make sure this path is correct

const SidebarMenu = [
  { name: "Dashboard", icon: <FaBars /> },
  { name: "Profile", icon: <FaUser /> },
  { name: "Settings", icon: <FaCog /> },
  { name: "Logout", icon: <FaSignOutAlt /> },
];

const TopMenu = [
  { name: "Home", icon: <FaHome /> },
  { name: "Movies", icon: <FaFilm /> },
  { name: "TV Shows", icon: <FaTv /> },
  { name: "Settings", icon: <FaCog /> },
];

const TVApp = () => {
  const [selectedSidebar, setSelectedSidebar] = useState(0);
  const [selectedTopMenu, setSelectedTopMenu] = useState(0);
  const [isSidebarFocused, setIsSidebarFocused] = useState(false);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [isContentActive, setIsContentActive] = useState(false);

  const handleExitFromContent = (target) => {
    setIsContentActive(false);

    if (target === "top") {
      setIsSidebarFocused(false);
    } else if (target === "sidebar") {
      setIsSidebarFocused(true);
      setIsSidebarExpanded(true);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      const key = event.keyCode;

      if (isContentActive) return;

      if (isSidebarFocused) {
        if (key === 38) setSelectedSidebar((prev) => Math.max(prev - 1, 0));
        if (key === 40)
          setSelectedSidebar((prev) =>
            Math.min(prev + 1, SidebarMenu.length - 1)
          );
        if (key === 39) {
          setIsSidebarFocused(false);
          setIsSidebarExpanded(false);
        }
        if (key === 13)
          console.log(`Sidebar Selected: ${SidebarMenu[selectedSidebar].name}`);
      } else {
        if (key === 37) {
          if (selectedTopMenu === 0) {
            setIsSidebarFocused(true);
            setIsSidebarExpanded(true);
          } else {
            setSelectedTopMenu((prev) => Math.max(prev - 1, 0));
          }
        }
        if (key === 39)
          setSelectedTopMenu((prev) =>
            Math.min(prev + 1, TopMenu.length - 1)
          );
        if (key === 13) {
          console.log(`Top Menu Selected: ${TopMenu[selectedTopMenu].name}`);
          if (TopMenu[selectedTopMenu].name === "Movies") {
            setIsContentActive(true);
          }
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [selectedSidebar, selectedTopMenu, isSidebarFocused, isContentActive]);

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  return (
    <div style={{ display: "flex", height: "100vh", backgroundColor: "#111" }}>
      {/* Sidebar */}
      <div
        style={{
          width: isSidebarExpanded ? "250px" : "80px",
          transition: "width 0.3s ease",
          padding: "20px",
          backgroundColor: "#222",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: isSidebarExpanded ? "flex-start" : "center",
        }}
      >
        <h2 style={{ color: "white", fontSize: isSidebarExpanded ? "18px" : "0px" }}>
          {isSidebarExpanded ? "Sidebar" : ""}
        </h2>
        {SidebarMenu.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px",
              margin: "5px 0",
              backgroundColor:
                isSidebarFocused && selectedSidebar === index ? "green" : "black",
              color: "white",
              cursor: "pointer",
              width: "100%",
              borderRadius: "5px",
            }}
          >
            <div
              style={{ fontSize: "24px", marginRight: isSidebarExpanded ? "10px" : "0px" }}
            >
              {item.icon}
            </div>
            <span style={{ display: isSidebarExpanded ? "inline" : "none" }}>
              {item.name}
            </span>
          </div>
        ))}
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, padding: "20px", textAlign: "center", overflow: "hidden" }}>
        <h1 style={{ color: "white", marginBottom: "20px" }}>Smart TV Navigation</h1>

        {/* Top Menu */}
        {!isContentActive && (
          <div>
            {TopMenu.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  fontSize: "24px",
                  margin: "10px",
                  padding: "10px",
                  backgroundColor:
                    !isSidebarFocused && selectedTopMenu === index ? "green" : "black",
                  color: "white",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                <div style={{ fontSize: "24px", marginRight: "10px" }}>{item.icon}</div>
                {item.name}
              </div>
            ))}
          </div>
        )}

        {/* Content Screens */}
        {isContentActive && selectedTopMenu === 1 && (
          <Movies handleExit={handleExitFromContent} />
        )}

        {/* Carousel only in Home */}
        {!isContentActive && selectedTopMenu === 0 && (
          <div
            style={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "80%",
                maxWidth: "900px",
                borderRadius: "10px",
                overflow: "hidden",
                boxShadow: "0px 4px 10px rgba(255, 255, 255, 0.1)",
              }}
            >
              <Slider {...carouselSettings}>
                <div>
                  <img
                    src="https://via.placeholder.com/900x450?text=Featured+Content+1"
                    alt="Slide 1"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
                <div>
                  <img
                    src="https://via.placeholder.com/900x450?text=Featured+Content+2"
                    alt="Slide 2"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
                <div>
                  <img
                    src="https://via.placeholder.com/900x450?text=Featured+Content+3"
                    alt="Slide 3"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
              </Slider>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TVApp;
